<template>
    <!-- List Contacts Page -->
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallinprogress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Contacts</span>
                    <a v-if="contactsToShowStyle == 'grid'">Grid View</a>
                    <a v-else>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center media-margin-bottom dis-none">
                    <button class="btn btn-new-primary btn-wide px-6 margin767 mr-4" v-if="active_tab == 'business' && userPermissions.contacts_business.permitted_actions.archive" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" :disabled="selectedContacts.length < 1" @click="selectedContacts.length ? $modal.show('archiveModal') : ''"><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Archive</button>
                    <button class="btn btn-new-primary btn-wide px-6 margin767 mr-4" v-if="active_tab == 'archive' && userPermissions.contacts_business.permitted_actions.retrieve" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" :disabled="selectedContacts.length < 1" @click="selectedContacts.length ? $modal.show('archiveModal'): ''"><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Retrieve</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4 margin767" @click="showFilters()">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <!-- <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="$modal.show('columnConfigContacts')">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button> -->
                    <button class="btn btn-new-primary btn-wide px-6 mr-4 margin767" disabled>
                        <img  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <!-- <button v-if="userPermissions.contacts_business.permitted_actions.delete || userPermissions.contacts_personal.permitted_actions.delete" class="btn btn-new-danger btn-wide px-6 ml-4" :disabled="selectedContacts.length < 1" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selectedContacts.length ? $modal.show('deleteContact') : ''">- Delete</button> -->
                    <button  class="btn btn-new-danger btn-wide px-6 mr-4 margin767" :disabled="selectedContacts.length < 1" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="permissionCheckForDelete()">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6 mr-4 margin767 margin483"  @click="permissionCheckForCreate()">+ Create New </button>
                </div>
            </div>
            <div class="d-flex flex-wrap align-items-center media-margin-bottom dis-none-ms">
                <button class="btn-new-primary btn-wide margin767" v-if="active_tab == 'business' && userPermissions.contacts_business.permitted_actions.archive" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" :disabled="selectedContacts.length < 1" @click="selectedContacts.length ? $modal.show('archiveModal') : ''">
                    <el-tooltip class="item" effect="dark" content="Archive" placement="top">
                        <i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18" style="padding-left: 8px;"></i>
                    </el-tooltip>
                </button>
                <button class="btn-new-primary btn-wide margin767" v-if="active_tab == 'archive' && userPermissions.contacts_business.permitted_actions.retrieve" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" :disabled="selectedContacts.length < 1" @click="selectedContacts.length ? $modal.show('archiveModal'): ''">
                    <el-tooltip class="item" effect="dark" content="Retrieve" placement="top">
                        <i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18" style="padding-left: 8px;"></i>
                    </el-tooltip>
                </button>
                <el-tooltip class="item" effect="dark" content="Filter" placement="top">
                    <button class="btn-new-primary btn-wide ml-4 margin767" @click="showFilters()">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;margin-left: 8px;"> 
                    </button>
                </el-tooltip>
                <!-- <button class="btn btn-new-primary btn-wide px-6 ml-4" @click="$modal.show('columnConfigContacts')">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button> -->
                <el-tooltip class="item" effect="dark" content="Export to Excel" placement="top">
                    <button class="btn-new-primary btn-wide ml-4 margin767" disabled style="background-color: #ABABAB;cursor: not-allowed;">
                        <img  src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px;margin-left: 8px;">
                    </button>
                </el-tooltip>
                <!-- <button v-if="userPermissions.contacts_business.permitted_actions.delete || userPermissions.contacts_personal.permitted_actions.delete" class="btn btn-new-danger btn-wide px-6 ml-4" :disabled="selectedContacts.length < 1" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selectedContacts.length ? $modal.show('deleteContact') : ''">- Delete</button> -->
                <button  class="btn-new-danger px-3 btn-wide ml-4 margin767" :disabled="selectedContacts.length < 1" :style="selectedContacts.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="permissionCheckForDelete()" style="padding-left: 8px;">
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                        <i class="icon icon-trash fs-20 pointer text-dark-blue"></i>
                    </el-tooltip>    
                </button>
                <button class="btn-new-green px-3 btn-wide ml-4 margin767 margin483"  @click="permissionCheckForCreate()" style="padding-left: 8px;">
                    <el-tooltip class="item" effect="dark" content="Create New" placement="top">
                        <i class="icon icon-plus fw-600 fs-20 pointer text-white"></i>
                    </el-tooltip> 
                </button>
            </div>
            <div v-if="showArchiveTab == false" class="d-flex dis-none-ms ml-6 mb-2" style="flex-grow: 1">
                <div class="d-flex ml-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                    <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:5px"></i>
                    <i v-if="search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                    <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_key" v-debounce:500ms="searchContacts" debounce-events="input"  placeholder="Search by First Name, Last Name"
                    style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em; padding-right: 10px;">
                </div>
                <!-- <div class="d-flex justify-content-center ml-2"
                    style="background: #fff; border-radius: 20px; width: 10em; height: 2.9em;">
                    <div class="d-flex justify-content-center align-items-center pointer"
                        style="width: 50%; border-right: 0.5px solid #cce3fc" @click="contactsToShowStyle = 'grid'">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/grid.svg" width="18">
                    </div>
                        <div class="d-flex justify-content-center align-items-center pointer"
                        style="width: 50%; border-left: 0.5px solid #cce3fc" @click="contactsToShowStyle = 'list'">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/list.svg" width="38">
                    </div>
                    <div class="d-flex justify-content-center align-items-center pointer ml-2"
                        style="width: 100%; " @click="contactsToShowStyle = 'list'">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/list.svg" width="38">
                    </div>
                </div> -->
            </div>
            <!-- Filter Chips Section -->
            <div class="filterSelectedChips mb-3" v-if="showfilterData.job_title.length || showfilterData.contact_name.length || showfilterData.company_name || showfilterData.industry_type.length || showfilterData.relation.length">
                <div class="pull-right pointer resetChips" @click="removeAllChips()"><i class="icon icon-close text-white fs-20"></i></div>
                <div class="d-flex align-items-center flex-wrap">
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.contact_name.length">Contact Name</span>
                    <span v-for="(name,contact_index) in showfilterData.contact_name" :key="contact_index">
                        <span class="filterChips" @click="removeChips(name,'contact_name')">
                            {{name}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.job_title.length">Job Title</span>
                    <span v-for="(job_title,title_index) in showfilterData.job_title" :key="title_index">
                        <span class="filterChips" @click="removeChips(job_title,'job_title')">
                            {{job_title}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.company_name">Company Name
                        <span class="filterChips text-black font-weight-normal" @click="removeChips(showfilterData.company_name,'company_name')">
                            {{showfilterData.company_name}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.industry_type.length">Industry Type</span>
                    <span v-for="(industry_type,type_index) in showfilterData.industry_type" :key="type_index">
                        <span class="filterChips" @click="removeChips(industry_type,'industry_type')">
                            {{industry_type}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.relation.length">Relation</span>
                    <span v-for="(relation,relation_index) in showfilterData.relation" :key="relation_index">
                        <span class="filterChips" @click="removeChips(relation,'relation')">
                            {{relation}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex" v-for="(show, index) in tab_show.sub_modules" :key="index">
                    <div class='slant-tabs' :class="{'activeTab':active_tab == show,'new-blue':active_tab == show, 'hide-state':active_tab != show}" @click="switchTabs(show)">
                        <span class="text-capitalize">{{show}}</span>
                    </div>
                </div>
                <div v-if="showArchiveTab == false" class="slant-tabs" :class="{'activeTab':active_tab == 'archive','new-blue':active_tab == 'archive' }" @click="switchTabs('archive')">
                    <span class="text-capitalize">Archive</span>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li :class="{'tab-current':active_tab == show}" v-for="(show, index) in tab_show.sub_modules" :key="index">
                                <a href="javascript:;" @click="switchTabs(show)" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span :class="{'tab-radius':show == 'personal'}" class="text-capitalize">{{show}}</span>
                                </a>
                            </li>
                            <li v-if="showArchiveTab == false" :class="{'tab-current':active_tab == 'archive'}">
                                <a href="javascript:;" @click="switchTabs('archive')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Archive</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div v-if="showArchiveTab == false" class="d-flex dis-none" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                    <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:5px"></i>
                    <i v-if="search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                    <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_key" v-debounce:500ms="searchContacts" debounce-events="input"  placeholder="Search by First Name, Last Name"
                    style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em; padding-right: 10px;">
                </div>
                    <!-- <div class="d-flex justify-content-center ml-2"
                        style="background: #fff; border-radius: 20px; width: 10em; height: 2.9em;">
                        <div class="d-flex justify-content-center align-items-center pointer"
                            style="width: 50%; border-right: 0.5px solid #cce3fc" @click="contactsToShowStyle = 'grid'">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/grid.svg" width="18">
                        </div>
                         <div class="d-flex justify-content-center align-items-center pointer"
                            style="width: 50%; border-left: 0.5px solid #cce3fc" @click="contactsToShowStyle = 'list'">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/list.svg" width="38">
                        </div>
                        <div class="d-flex justify-content-center align-items-center pointer ml-2"
                            style="width: 100%; " @click="contactsToShowStyle = 'list'">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/crm/list.svg" width="38">
                        </div>
                    </div> -->
                </div>
            </div>
            <business-contacts :filters="filters" @listDataEmit="getListDataEmit" v-if="business" @selectedContactsList = selectedContactsList :active_status="active_tab == 'business' ? 'active' : 'archived'"></business-contacts>
            <personal-contacts v-if="personal" @listDataEmit="getListDataEmit" @selectedContactsList="selectedContactsList" ></personal-contacts>
        </div>
        <div v-show="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data :contact_type="business == true ? 'business' : 'personal'" :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></filter-data>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <delete-contact modal_name="deleteContact" @deleteContacts="deleteContacts" @cancelDelete="cancelDelete"></delete-contact>
        <archive-modal modal_name="archiveModal" @archiveData="archiveData" :origin="'contacts'" @cancelArchive="cancelArchive"></archive-modal>
    </div>
</template>
<script>
const FilterData = () => import("../Contacts/FilterData.vue");
import DeleteContact from "../alertModals/DeleteContact";
import ArchiveModal from "../alertModals/ArchiveModal";
const BusinessContacts = () => import("./BusinessContacts");
const PersonalContacts = () => import("./PersonalContacts");
import { HalfCircleSpinner } from "epic-spinners";
import contacts from "../mixins/contacts.js"
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event';
import user_permission from '../mixins/user_permission.js';
export default {
    mixins: [contacts,user_permission],
    data() {
        return {
            showArchiveTab: false,
            warning_msg: "",
            success_msg: "",
            showCreatePersonal:false,
            showCreateBusiness: false,
            active_tab: 'business',
            tab_show:[],
            business: false,
            personal: false,
            archive :true,
            ajaxCallinprogress: false,
            search_key: "",
            contactsToShow: "Business Contacts",
            contactsToShowStyle: "list",
            skip: 0,
            hide_filters: false,
            display_filters: false,
            limit: 10,
            count: 0,
            count1: 0,
            start: 0,
            end: 0,
            total: 0,
            filter: false,
            filtersLength: 0,
            contacts: [],
            selectedContacts: [],
            industry: [],
            companies: [],
            relation_options: [],
            tag_options: [],
            filters: {
                job_title: [],
                industry_type: [],
                company_name: [],
                contact_name: [],
                relation:[],
            },
            showfilterData:{
                job_title: [],
                industry_type: [],
                company_name: null,
                contact_name: [],
                relation:[],
            },
            isLoading: {
                industry_type: false,
                reltion:false,
                company_name: false,
                contact_name: false
            },
            columnConifg: [],
            contacts: [
            ],
            add_to_list: false,
            bottom: false,
            selectedData: null,
            archiveEdit : '',
            personalContacts: [],
        }
    },
    components: {
        DeleteContact,
        HalfCircleSpinner,
        BusinessContacts,
        PersonalContacts,
        FilterData,
        SweetModal,
        ArchiveModal
    },
    methods: {
        clearSearch(){
            this.search_key = ""
            if(this.active_tab == 'business') {
                this.search_key = ""
                this.$refs.searchInput.focus();
                this.switchTabs('business');
            }
            else if(this.active_tab == 'personal') {
                this.search_key = ""
                this.$refs.searchInput.focus();
                this.searchContacts()
                this.switchTabs('personal');
            }
            else if(this.active_tab == 'archive') {
                this.search_key = ""
                this.$refs.searchInput.focus();
                this.switchTabs('archive');
            }
        },
        //permission to check the create contact
        permissionCheckForCreate() {
            if(this.active_tab == 'business') {
                if(!this.userPermissions.contacts_business.permitted_actions.create ) {
                    this.$toasted.global.error("Permission Denied")
                } else {
                    this.$router.push('/create_contact/new')
                }
            }
            if(this.active_tab == 'personal') {
                if(!this.userPermissions.contacts_personal.permitted_actions.create ) {
                    this.$toasted.global.error("Permission Denied")
                } else {
                    this.$router.push('/create_contact/new')
                }
            }
        },
        //permission to check the delete contact
        permissionCheckForDelete() {
            if(this.loggedInUser.user_role == "sales_manager" || this.loggedInUser.user_role == "generic_user"){
                if(this.active_tab == 'business' || this.active_tab == 'archive') {
                    if(this.selectedContacts.length){
                        if(!this.userPermissions.contacts_business.permitted_actions.delete ) {
                        this.$toasted.global.error("Permission Denied")
                        } else {
                            this.$modal.show('deleteContact')
                        }
                    }
                }
                if(this.active_tab == 'personal') {
                    if(this.selectedContacts.length){
                        if(!this.userPermissions.contacts_personal.permitted_actions.delete ) {
                        this.$toasted.global.error("Permission Denied")
                        } else {
                            this.$modal.show('deleteContact')
                        }
                    }
                }
            } else if(this.loggedInUser.user_role == "sales_person" || this.loggedInUser.user_role == "team_lead"){
                if(this.active_tab == 'business' || this.active_tab == 'archive') {
                    if(this.selectedContacts.length){
                        this.$toasted.global.error("Permission Denied")
                    }
                }
                if(this.active_tab == 'personal') {
                    if(this.selectedContacts.length){
                        if(!this.userPermissions.contacts_personal.permitted_actions.delete ) {
                        this.$toasted.global.error("Permission Denied")
                        } else {
                            this.$modal.show('deleteContact')
                        }
                    }
                }
            }
        },
        //set the sleected contacts as null 
        getListDataEmit() {
            this.selectedContacts = [];
        },
        //get the archive data 
        async archiveData(){
            if(this.selectedContacts.length){
                let params = {
                    id: this.selectedContacts
                }
                let response
                if(this.active_tab == 'business'){
                    response = await this.moveBusinessContacts('archive',params)
                    this.success_msg = "Contacts Moved to Archive Successfully"
                } else if(this.active_tab == 'archive'){
                    response = await this.moveBusinessContacts('active',params)
                    this.success_msg = "Contacts Retrieved to Business Successfully"
                }
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selectedContacts = []
                    this.$refs.success_modal.close();
                    EventBus.$emit("selected_data")
                    EventBus.$emit("load_data",this.filters)
                }, 3000);
            }
        },
        //Api call to get the sub module permission 
        async submodulePermission(){
            // this.ajaxCallinprogress = true;
            // this.showArchiveTab = true;
            // let params = {
            //     id: 'sub_module',
            //     module_name : 'contacts'
            // }
            // let response = await this.permittedModules(params)
            this.tab_show = {
                sub_modules: []
            }
            if(this.userPermissions.contacts_business.permitted_actions.view && this.userPermissions.contacts_personal.permitted_actions.view) {
                this.tab_show.sub_modules = ['business', 'personal']
            } else if(this.userPermissions.contacts_business.permitted_actions.view) {
                this.tab_show.sub_modules = ['business']
            } else if(this.userPermissions.contacts_personal.permitted_actions.view) {
                this.tab_show.sub_modules = ['personal']
            }
            this.showArchiveTab = false;
            this.showTabs(this.tab_show)
            // this.ajaxCallinprogress = false;
        },
        //setting the selected contact list value
        /**@params = value */
        selectedContactsList(value){
            this.selectedContacts = value
        },
        //Api call for delete contacts
        async deleteContacts() {
            //selecting the active tab business/personal/archive to delete the contacts
            if(this.active_tab == 'business'){
                let params = {
                    id: this.selectedContacts
                }
                let res = await this.deleteBusinessContact("delete",params)
                this.$modal.hide("deleteBusiness");
                this.success_msg = "Business Contacts Deleted Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selectedContacts = []
                    this.$refs.success_modal.close();
                }, 3000);
                EventBus.$emit("load_data",this.filters)
            }
            if(this.active_tab == 'personal'){
                let params = {
                    id: this.selectedContacts
                }
                let response = await this.deletePersonalContact("delete",params)
                this.$modal.hide("deletePersonal");
                this.success_msg = "Personal Contacts Deleted Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selectedContacts = []
                    this.$refs.success_modal.close();

                }, 3000);
                EventBus.$emit("load_data",this.filters)
            }
            if(this.active_tab == 'archive') {
                let params = {
                    id: this.selectedContacts
                }
                let res = await this.deleteBusinessContact("delete",params)
                this.$modal.hide("deleteBusiness");
                this.success_msg = "Archive Contacts Deleted Successfully"
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selectedContacts = []
                    this.$refs.success_modal.close();
                }, 3000);
                EventBus.$emit("load_data",this.filters)
            }
        },
        //hide the filter modal
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        //show the filter modal
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        //remove the chips
        /**@params = value, @params = key */
        removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        //show th tabs
        /**@params = data */
        showTabs(data){
            let businessData = data.sub_modules.includes('business')
            let personalData = data.sub_modules.includes('personal')
            if(businessData) {
                this.business = true
            }  else if(personalData) {
                this.personal = true
            }
        },
        //Swtich the tabs 
        /**@params = obj */
        switchTabs(obj){
            if(obj == 'business'){
                this.active_tab = 'business'
                this.business = true
                this.personal = false
                this.selectedContacts = []
                localStorage.setItem("TabContactsActive",'Business')
                EventBus.$emit("status_change",'active')
                EventBus.$emit("checked", 'checked')
                EventBus.$emit("archive_status",'archive')
                this.search_key = ""
            }
            else if(obj == 'personal'){
                this.search_key = ""
                this.active_tab = 'personal'
                this.business = false
                this.personal = true
                this.selectedContacts = []
                //this.archive = false
                localStorage.setItem("TabContactsActive",'Personal')
                EventBus.$emit("checked", 'checked')
                EventBus.$emit("archive_status",'archive')
            }
            else if(obj == 'archive'){
                this.active_tab = 'archive'
                this.business = true
                this.personal = false
                this.selectedContacts = []
                localStorage.setItem("TabContactsActive",'Archive')
                EventBus.$emit("status_change",'archived')
                EventBus.$emit("checked", 'checked')
                EventBus.$emit("archive_status",'retrieve')
                this.search_key = ""
            }
        },
        //update the filters 
        /**@params = params */
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            this.showfilterData = {
                company_name: params.value1.company_name,
                contact_name:params.value1.contact_name,
                job_title:params.value1.job_title,
                relation:params.value1.relation,
                industry_type: params.value1.industry_type
            }
            this.filters = {
                company_name: params.value1.company_name == null || params.value1.company_name == '' ? [] : [params.value1.company_name] ,
                contact_name:params.value1.contact_name,
                job_title:params.value1.job_title,
                relation:params.value1.relation,
                industry_type: params.value1.industry_type
            }
            EventBus.$emit("load_data",this.filters)
        },
        //remove the chips
        /**@params = value, @params = key */
        removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        //remove all the chips
        removeAllChips(){
            this.filters = {
                contact_name: [],
                company_name: null,
                industry_type: [],
                job_title: []
            }
            this.showfilterData = {
                contact_name: [],
                company_name: null,
                industry_type: [],
                job_title: []
            }
            EventBus.$emit('removeAllchip')
            if(!this.display_filters) {
                EventBus.$emit("load_data",this.filters)
            }
        },
        
        searchContacts() {
            EventBus.$emit("search_data",this.search_key)
        },
        //cancel the delete modal
        cancelDelete(){
            //this.selectedContacts = []
            //EventBus.$emit("selected_data")
        },
        //cancel the archive modal
        cancelArchive(){
            //this.selectedContacts = []
            //EventBus.$emit("selected_data")
        }
    },
    mounted() {
        localStorage.setItem("TabContactsActive",'Business')
        this.submodulePermission();
    },
    created() {
        // this.getContacts();
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },

    },
    watch: {
        search_key: function () {
            //  this.getContacts();
        },
        contactsToShow: function () {
            //  this.getContacts();
        },
        count: function () {
            // this.getContacts();
        }
    },
}
</script>

<style scoped>
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }

    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }

    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }

    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: 13em;
    }

    .arrow-right {
        width: 0;
        height: 0;
        border-top: 14px solid transparent;
        border-bottom: 14px solid transparent;
        border-right: 14px solid #fff;
    }

    .filter-div {
        position: fixed;
        top: 22em;
        right: 3em;
        width: 50em;
        border-radius: 7.5px;
        z-index: 9999;
    }

    @media only screen and (min-width: 36px) {
        /* .salesForecastCalendar .mx-datepicker-popup {
			left: -265px !important;
		} */
    }
    #lazy-load-notify {
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 30px;
        -ms-overflow-style: none;
        /* IE 11 */
        scrollbar-width: none;
        /* Firefox 64 */
    }

    #lazy-load-notify::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
    .scm-filters {
        height: fit-content !important;
        overflow: auto !important;
    }
    .show {
		display: block !important;
	}
    .hide-state {
        display: block !important;
    }
    .tab-radius{
        border-top-left-radius: 35px !important;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media (min-width: 768px) and (max-width: 990px){
        .media-margin-bottom{
            margin-bottom: 10px !important;
        }
    }
    @media (min-width: 484px) and (max-width: 767px){
        .margin767{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 483px) {
        .margin483{
            margin-bottom: 10px !important;
            margin-top: 10px !important;
        }
    }
    @media only screen and (max-width: 540px) {
        .dis-none{
            display: none !important;
        }
    }
    @media only screen and (min-width: 541px) {
        .dis-none-ms{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacts/ContactsListView.vue